let counter = 0;

export const getRuntimeUid = () => (counter += 1);
